import React from "react";

const xidBlackLogo = require("../assets/black-logo.png");
const xidWhiteLogo = require("../assets/white-logo.png");

interface IHeaderProps {
  logoColor: "white" | "black";
}

const Header = ({ logoColor }: IHeaderProps) => {
  return (
    <>
      <img src={logoColor === "white" ? xidWhiteLogo : xidBlackLogo}></img>
      <span className="text-header">
        Own your data.
        <br /> Earn rewards.
      </span>
    </>
  );
};

export default Header;
